import { render, staticRenderFns } from "./Bottom.vue?vue&type=template&id=964f8160"
import script from "./Bottom.vue?vue&type=script&lang=js"
export * from "./Bottom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports